import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniGameSelectorComponent } from './mini-game-selector/mini-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MiniGameCoreService } from './mini-game-core.service';

@NgModule({
  declarations: [MiniGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [MiniGameCoreService],
  exports: [MiniGameSelectorComponent],
})
export class MiniGameCoreModule {}
